import styled from "styled-components";
import theme from "~/styles/theme";
import { Button } from "~/components/elements";
import { HashLink } from "react-router-hash-link";

export const HeaderContainer = styled.div`
  position: fixed;
  width: 100%;
  z-index: 10;
  top: 0;
`;

export const HeaderBg = styled.div`
  background-color: ${theme.palette.brand.primary.key};
  height: 64px;
  width: 100%;
  padding: 0 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0;
    height: 75px;
  }
`;

export const ContentHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: auto;
  }
`;

export const LogoHolder = styled.div`
  display: flex;
`;

export const MenuIconHolder = styled.div`
  display: flex;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: none;
  }
`;

export const MenuHolder = styled.div`
  display: flex;
`;

export const Menu = styled.div`
  background-color: ${theme.palette.brand.secondary.key};
  display: flex;
  flex-direction: column;
  top: 63px;
  position: absolute;
  width: 100%;
  right: 0;
  height: calc(100dvh - 63px);
  z-index: 100;
  overflow: auto;
  justify-content: space-between;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    height: auto;
    position: relative;
    top: auto;
    width: auto;
  }
`;

export const MenuMobileHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30%;
  margin-bottom: 88px;

  span,
  a {
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color: ${theme.palette.neutral.primary.key};
    text-decoration: none;

    &:not(:last-child) {
      margin-bottom: 32px;
    }
  }
`;

export const ActionsMenuMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 56px;
  margin-bottom: 40px;

  a {
    text-decoration: none;
    width: 100%;
  }

  button {
    width: 100%;
  }
`;

export const ActionsMenuDesk = styled.div`
  display: none;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;
  }

  a {
    text-decoration: none;
  }
`;

export const BtnLogin = styled(Button)`
  display: flex;
  align-items: center;
  background: transparent;
  border: 2px solid ${theme.palette.brand.primary.key};
  margin-bottom: 24px;
  cursor: pointer;
  background-color: none;
  padding: 10px 24px;
  border-radius: 32px;
  font-weight: 400;
  width: 100%; 

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 0;
    border: 2px solid ${theme.palette.neutral.primary.light};
    width: auto;

    svg path {
      fill: white;
    }

  }

  span {
    color: white;
    display: flex;

    &.text-blue {
      color: #0D5BA8;
    }

    svg {
      margin-right: 8px;
    }

  }

  &:hover {
    border-color: ${theme.palette.neutral.primary.light};
    background-color: ${theme.palette.neutral.primary.light};;
    color: #0D5BA8;
    
    span {
      display: flex;
      color: #0D5BA8;

      svg {
        margin-right: 8px;

        circle {
          fill: ${theme.palette.brand.primary.key};
        }

        path {
          fill: ${theme.palette.brand.primary.key};
        }
      }
    }
  }


`;

export const BtnParticipe = styled(Button)`
  background: #FCC800;
  border: none;
  span {
    font-weight: 700;
  }
`;

export const SubMenu = styled.div`
  display: none;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${theme.palette.brand.secondary.key};
    padding: 16px 0;
  }
`;

export const MessageEnd = styled.div`
  background-color: #e64e52;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  padding: 5px 0;
`;

export const HashLinkStyle = styled(HashLink)`
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  span {
    color: ${theme.palette.neutral.primary.key};
  }

  &:hover {
    text-decoration: underline;
    span {
      color: ${theme.palette.neutral.primary.key};
    }
  }
`;

export const GridLinks = styled.div`
  display: flex
  gap: 24px;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    display: none;
  }

  a:hover {
    color: white !important;
    span {
      color: white !important;
    }
  }
`
